// SellerAppStore — same App Store as buyers, available to sellers too.
// Sellers can install Dropship, Inventory, RFQ, AI Assistant, PO Generator etc.
// Backed by /api/apps (role-agnostic).
import BuyerAppStore from "../buyer/BuyerAppStore";
export default BuyerAppStore;
